import { FormattedMessage } from "react-intl";
import { Button } from "@ps-design-system/components/Button";

type EditFieldButtonProps = {
  /** Should show Edit if true, Add if false */
  showEditLabel: boolean;
  onClick?: () => void;
};

/**
 * The underlined "Edit" affordance shown next to an editable profile field.
 * `onClick` is optional while the per-field edit flows are still being built.
 */
export const EditFieldButton = ({
  showEditLabel,
  onClick,
}: EditFieldButtonProps) => {
  return (
    <Button appearance="black" onClick={onClick} variant="underline-m">
      {showEditLabel ? (
        <FormattedMessage
          id="hosting.profile_page.edit_field_button.edit"
          defaultMessage="Edit"
        />
      ) : (
        <FormattedMessage
          id="hosting.profile_page.edit_field_button.add"
          defaultMessage="Add"
        />
      )}
    </Button>
  );
};
